var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTailVertical = function SvgTailVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "62px",
    height: "40px",
    viewBox: "0 0 62 40",
    enableBackground: "new 0 0 62 40",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#e9e9e8",
    fill: "currentColor",
    d: "M22,0C22,35,0,39.939,0,39.939s15.783,1.316,36.354-8.74 C43.205,36.701,52.529,40,62,40"
  }))));
};
export default SvgTailVertical;